import { BlocksRenderer as StrapiBlocksRenderer } from '@strapi/blocks-react-renderer'
import { BlocksRendererProps, FixedLinkInlineNode } from './types'
import Link from 'components/link/Link'
import { Img } from '@boltenergy-be/design-system'
import Image from 'next/image'
import { hasPublicId } from './utils'

const BlocksRenderer = ({ blocks, ...props }: BlocksRendererProps) => {
  return (
    <StrapiBlocksRenderer
      {...props}
      blocks={{
        image: ({ image }) => {
          return (
            <figure>
              {hasPublicId(image.provider_metadata) ? (
                <Img fill={true} publicId={image.provider_metadata.public_id} alt={image.alternativeText} />
              ) : (
                <Image src={image.url} alt={image.alternativeText} />
              )}
              {!!image.caption && <figcaption className="text-sm text-subdued">{image.caption}</figcaption>}
            </figure>
          )
        },
        link: ({ url, children, rel, target }: FixedLinkInlineNode) => {
          const isInternalLink = url.startsWith('https://boltenergie.be') || url.startsWith('https://www.boltenergie.be')

          if (isInternalLink) {
            const path = url.split('boltenergie.be')[1]

            return (
              <Link variant="inline" href={path} {...{ rel, target }}>
                {children}
              </Link>
            )
          }

          return (
            <Link as="a" variant="inline" href={url} {...{ rel, target }}>
              {children}
            </Link>
          )
        },
        ...blocks
      }}
    />
  )
}

export default BlocksRenderer
